/**
 * @generated SignedSource<<410527db60033f4781870be85f1e8a10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactUpdateInput = {
  externalRef?: string | null;
  accountId?: string | null;
  email?: string | null;
  salutation?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
  dob?: any | null;
  gender?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  homePhone?: string | null;
  addressLineOne?: string | null;
  addressLineTwo?: string | null;
  city?: string | null;
  state?: string | null;
  countryId?: string | null;
  zip?: string | null;
  status?: string | null;
  type?: string | null;
  businessName?: string | null;
  occupation?: string | null;
  source?: string | null;
  meta?: any | null;
  workflowStatus?: any | null;
  photoUrls?: any | null;
  createdBy?: string | null;
  userId?: string | null;
  unmindUserId?: string | null;
  timezone?: string | null;
  locale?: string | null;
  contactAccountId?: string | null;
  sessionLimitOverride?: number | null;
};
export type contactUpdateMutation$variables = {
  id: string;
  input: ContactUpdateInput;
};
export type contactUpdateMutation$data = {
  readonly updateContact: {
    readonly contact: {
      readonly " $fragmentSpreads": FragmentRefs<"contactFragment">;
    };
  };
};
export type contactUpdateMutation = {
  variables: contactUpdateMutation$variables;
  response: contactUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyCode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contactUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactPayload",
        "kind": "LinkedField",
        "name": "updateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "contactFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contactUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContactPayload",
        "kind": "LinkedField",
        "name": "updateContact",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unmindUserId",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salutation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dob",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "photoUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mobilePhone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workPhone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "homePhone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLineOne",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLineTwo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "occupation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactActivityHistory",
                "kind": "LinkedField",
                "name": "contactActivityHistories",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactTeamMember",
                "kind": "LinkedField",
                "name": "contactTeamMembers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "teamMember",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserProfile",
                        "kind": "LinkedField",
                        "name": "memberUserProfile",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Fee",
                    "kind": "LinkedField",
                    "name": "fee",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v13/*: any*/),
                      (v10/*: any*/),
                      (v14/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesOrder",
                "kind": "LinkedField",
                "name": "salesOrders",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerFirstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "customerLastName",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventRecurringId",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "taxAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "discountAmount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "grandAmount",
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paymentTerms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIn",
                    "kind": "LinkedField",
                    "name": "paymentIns",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v6/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "payerEmail",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SalesOrder",
                        "kind": "LinkedField",
                        "name": "salesOrder",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Payment",
                    "kind": "LinkedField",
                    "name": "payment",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paidAt",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SessionLimitPayload",
                "kind": "LinkedField",
                "name": "sessionLimits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sessionLimitType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "amountRemaining",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expiryDate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5753d9ee5fa22ac557f7796d0e472f91",
    "id": null,
    "metadata": {},
    "name": "contactUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation contactUpdateMutation(\n  $id: ID!\n  $input: ContactUpdateInput!\n) {\n  updateContact(id: $id, input: $input) {\n    contact {\n      ...contactFragment\n      id\n    }\n  }\n}\n\nfragment contactActivityHistoryInlineFragment on ContactActivityHistory {\n  id\n  type\n  description\n  createdAt\n  meta\n}\n\nfragment contactFragment on Contact {\n  id\n  firstName\n  lastName\n  source\n  email\n  accountId\n  createdAt\n  createdBy\n  unmindUserId\n  status\n  salutation\n  dob\n  preferredName\n  gender\n  photoUrls\n  countryId\n  mobilePhone\n  workPhone\n  homePhone\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  businessName\n  occupation\n  contactActivityHistories {\n    ...contactActivityHistoryInlineFragment\n    id\n  }\n  contactTeamMembers {\n    ...contactTeamMemberInlineFragment\n    id\n  }\n  salesOrders {\n    ...salesOrderBaseFragment\n    ...salesOrderAmountFragment\n    ...salesOrderPaymentsFragment\n    ...salesOrderBaseInlineFragment\n    ...salesOrderAmountInlineFragment\n    ...salesOrderPaymentsInlineFragment\n    id\n  }\n  ...contactSessionLimitsRemainingFragment\n  ...contactSessionLimitsRemainingInlineFragment\n}\n\nfragment contactSessionLimitsRemainingFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n  }\n}\n\nfragment contactSessionLimitsRemainingInlineFragment on Contact {\n  sessionLimits {\n    sessionLimitType\n    amountRemaining\n    expiryDate\n  }\n}\n\nfragment contactTeamMemberInlineFragment on ContactTeamMember {\n  id\n  teamMember {\n    id\n    memberUserProfile {\n      firstName\n      lastName\n      id\n    }\n  }\n  fee {\n    ...feeInlineFragment\n    id\n  }\n}\n\nfragment feeInlineFragment on Fee {\n  id\n  name\n  amount\n  createdAt\n  createdBy\n  currencyCode\n  description\n  externalRef\n  type\n}\n\nfragment paymentBaseInlineFragment on Payment {\n  id\n  paidAt\n  amount\n  currencyCode\n  accountId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderAmountFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderAmountInlineFragment on SalesOrder {\n  subAmount\n  taxAmount\n  totalAmount\n  discountAmount\n  grandAmount\n  currencyCode\n  paymentTerms\n}\n\nfragment salesOrderBaseFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n}\n\nfragment salesOrderBaseInlineFragment on SalesOrder {\n  id\n  externalRef\n  accountId\n  userId\n  customerEmail\n  customerFirstName\n  customerLastName\n  status\n  totalAmount\n  grandAmount\n  currencyCode\n  meta\n  eventRecurringId\n  createdAt\n  updatedAt\n  deletedAt\n  payment {\n    ...paymentBaseInlineFragment\n    id\n  }\n}\n\nfragment salesOrderPaymentsFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n\nfragment salesOrderPaymentsInlineFragment on SalesOrder {\n  paymentIns {\n    amount\n    createdAt\n    currencyCode\n    payerEmail\n    externalRef\n    salesOrder {\n      id\n      externalRef\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c5f7c45be6c03852de75fd35a0e4133";

export default node;
